
import api from './api'

import { useCache } from '@/helpers/cache'
import { useDownload } from '@/helpers/download'

export default {    
    
    count(params = {}) {

        return api.get('/budgets', { params })
            .then( response => parseInt(response.headers['x-pagination-count']) )
    },

    get(id) {

        return api.get('/budgets/' + id, { cache: false })
            .then( json => {
                let budget = json.data
                return budget
            })
    },

    getXlsx(params = {}) {

        return new Promise((resolve, reject) => {

            api.post('/budgets/file', null, { params: params })
                .then( response => {
                    if ( response.status === 204 ) {
                        reject('Aucun fichier à télécharger') 
                    }

                    useDownload(response.headers.location)
                        .then(() => resolve() )
                })
                .catch(() => reject())
        }) 
    },

    list(params = {}) {

        return api.get('/budgets', { params })
            .then( json => json.data )
            
    },

    patch(budget) {

        return api.patch('/budgets/' + budget.id, budget)
            .finally(() => {
                useCache().clear('/budgets')
            })
    },

    post(budget) {

        return api.post('/budgets', budget)
            .finally(() => {
                useCache().clear('/budgets')
            })
    },

    search(params = {}) {

        return api.get('/budgets', { params })
            .then( json => json.data )            
    } 
}
